import http from 'utils/http'
import headersBuilder from 'utils/login/basicHeadersBuilders'

const login = credentials => {
  const urlLogin =
    !!credentials && !!credentials.staySigned
      ? `/user/v1/login?remember-me=true`
      : `/user/v1/login`
  return http.post(urlLogin, undefined, headersBuilder(credentials), false)
}

const preLogin = credentials => http.post('/user/v1/login/pre-login', credentials)

const logout = () => http.post('/user/v1/logout')

export default {
  login,
  preLogin,
  logout
}



// WEBPACK FOOTER //
// ./src/services/loginService.js